import React from 'react';
import { Link } from 'react-router-dom';
import logo from '../assets/logo.png';

export default function Footer() {
  return (
    <footer className="site-footer">
      {/* Essential Contact Strip */}
      <div className="footer-top">
        <div className="container">
          <div className="footer-contact-strip">
            <div className="footer-contact-item">
              <i className="fas fa-map-marker-alt" style={{ color: '#E3501D' }}></i>
              <div>
                <p>Headquarters</p>
                <h4>Shanghai, China</h4>
              </div>
            </div>
            <div className="footer-contact-item">
              <i className="fas fa-phone-alt" style={{ color: '#E3501D' }}></i>
              <div>
                <p>Talk to Us</p>
                <h4>+86 152 5809 2554</h4>
              </div>
            </div>
            <div className="footer-contact-item">
              <i className="fas fa-envelope" style={{ color: '#E3501D' }}></i>
              <div>
                <p>Email</p>
                <h4>support@eaststarmarine.com</h4>
              </div>
            </div>
            <div className="footer-contact-item">
              <i className="far fa-clock" style={{ color: '#E3501D' }}></i>
              <div>
                <p>Support</p>
                <h4>24/7, Every Day</h4>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Simplified Branding & Copyright Section */}
      <div className="container">
        <div style={{ 
          display: 'flex', 
          justifyContent: 'space-between', 
          alignItems: 'center', 
          padding: '30px 0', 
          flexWrap: 'wrap', 
          gap: '20px',
          borderTop: '1px solid rgba(255,255,255,0.05)'
        }}>
          
          <div style={{ display: 'flex', alignItems: 'center', gap: '15px' }}>
            <Link to="/">
              <img 
                src={logo} 
                alt="East Star Marine Diamond Star" 
                style={{ 
                  width: "60px", 
                  height: "auto",
                  filter: 'invert(42%) sepia(87%) saturate(2250%) hue-rotate(345deg) brightness(93%) contrast(92%)' 
                }}
              />
            </Link>
            <p style={{ margin: 0, fontSize: '14px', color: 'rgba(255,255,255,0.6)' }}>
              © {new Date().getFullYear()} East Star Marine. All rights reserved.
            </p>
          </div>

          <div style={{ display: 'flex', gap: '20px', fontSize: '14px' }}>
            <Link to="/about" style={{ color: 'rgba(255,255,255,0.6)', textDecoration: 'none' }}>About</Link>
            <Link to="/products" style={{ color: 'rgba(255,255,255,0.6)', textDecoration: 'none' }}>Products</Link>
            <Link to="/services" style={{ color: 'rgba(255,255,255,0.6)', textDecoration: 'none' }}>Services</Link>
            <Link to="/contact" style={{ color: 'rgba(255,255,255,0.6)', textDecoration: 'none' }}>Contact</Link>
          </div>

        </div>
      </div>
    </footer>
  );
}